export class ImpressumAttributes {
    sectionHeading: string;
    sectionSubHeading: string;
    htmlContent: string;
}
